import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {RouterChangeService} from '../../core/services/router-change.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
  standalone: false
})
export class SideBarComponent implements OnInit {

  activeTab = '';
  activeUrl = 'home';

  menuOptions = [
    {label: 'Home', icon: 'las la-chart-bar', link: 'home', show: true, activeURLs: ['/home']},
    {
      label: 'Users',
      icon: 'las la-user-cog',
      link: '/users',
      show: true,
      activeURLs: ['/users', '/organizations', '/quotes', '/claim', '/podcasts']
    },
    {
      label: 'Marketplace',
      icon: 'las la-store',
      link: '/marketplace/books',
      show: true,
      activeURLs: ['/marketplace/projects', '/marketplace/books', '/marketplace/satire', '/marketplace/requests']
    },
    {label: 'Entities', icon: 'las la-user-friends', link: '/entities', show: true, activeURLs: ['/entities']},
    {label: 'Surveys', icon: 'las la-poll', link: '/surveys', show: true, activeURLs: ['/surveys']},
    {
      label: 'Management',
      icon: 'las la-tasks',
      link: '/super-categories',
      show: true,
      activeURLs: ['/super-categories', '/categories', '/memberships', '/rating-categories']
    },
    {
      label: 'Import data',
      icon: 'las la-file-import',
      link: '/import/import-users',
      show: true,
      activeURLs: ['/import/import-users', '/import/import-entities', '/import/import-ratings', '/import/import-entity-lookup', '/import/import-demographic-clock-cities']
    },
    {
      label: 'CMS',
      icon: 'las la-server',
      link: '/banners',
      show: true,
      activeURLs: ['/banners', '/icons', '/nfts-collection', '/cms/hindutva-laboratory']
    },
    {
      label: 'Communication',
      icon: 'las la-handshake',
      link: '/news',
      show: true,
      activeURLs: ['/news', '/suggestions']
    },

  ];

  constructor(
    private routerChangeService: RouterChangeService
  ) {
    this.routerChangeService.activeRoute.subscribe((e) => {
      this.activeUrl = e.url;
    });
  }

  ngOnInit(): void {
    this.activeTab = sessionStorage.getItem(environment.activeTab);
  }

  changeTab(tab: string): void {
    this.activeTab = tab;
    sessionStorage.setItem(environment.activeTab, tab);
  }

  isActive(activeUrls: any = [], searchString: string = ''): boolean {
    return activeUrls.some(item => searchString.includes(item));
  }
}
